// extracted by mini-css-extract-plugin
module.exports =  {"quick-questions-carousel":"aysadoa","quickQuestionsCarousel":"aysadoa","carousel-quick-question":"Cgff_UV","carouselQuickQuestion":"Cgff_UV"};